import React from 'react'
import { Container } from 'react-bootstrap'

const Footer = () => {
  return (
    <Container>
      {/* Call-to-Action */}
      <h2 className="text-accent mt-5 monospace">
        Let’s build the next big thing — together.
      </h2>
    </Container>
  )
}

export default Footer